type CountWithTotal = {
  count: number
  total: number
}

const empty: CountWithTotal = { count: 0, total: 0 }

const CountWithTotal = { empty }

export { CountWithTotal }
